import { render, staticRenderFns } from "./buy_new.vue?vue&type=template&id=f26c3a4a&scoped=true&"
import script from "./buy_new.vue?vue&type=script&lang=js&"
export * from "./buy_new.vue?vue&type=script&lang=js&"
import style0 from "./buy_new.vue?vue&type=style&index=0&id=f26c3a4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26c3a4a",
  null
  
)

export default component.exports